import type { SearchFilters } from "../types";

const rangeRegex = /(\w*)([GL]te)$/;

/**
 * Convert serialized filters into SearchRequest body
 */
function parseFilters(filters: URLSearchParams | FormData): SearchFilters {
  // eslint-disable-next-line
  const obj: any = {};

  for (const [key, val] of filters) {
    if (["name", "type"].includes(key)) {
      // Set keys with single string value
      if (val !== "") obj[key] = val;
    } else if (key.match(rangeRegex)) {
      // Key is one of two range pairs with Gte or Lte suffix
      if (filters instanceof FormData) {
        // When parsing FormData, we can just add the key=value pair to update the URLSearchParams
        if (val !== "") obj[key] = val;
      } else {
        // But when parsing URLSearchParams, we need to create a shape for the API post body
        // So separate the field into its name and the Gte/Lte suffix
        const prefix = key.match(rangeRegex)?.[1] as string;
        const suffix = key.match(rangeRegex)?.[2] as string;
        // Convert price fields into number values
        const numOrDate = prefix.includes("Price") ? Number(val) : val;
        // Then update actual key while preserving the other range value
        obj[prefix] = { ...obj[prefix], [suffix.toLowerCase()]: numOrDate };
      }
    } else if (obj[key]) {
      // Update keys that already exist as string[] with appended value
      obj[key].push(val);
    } else {
      // Create string[] value for first encounter of key, later encounters will be handled above
      obj[key] = [val];
      // NOTE: the `sort` key is also handled here, although it should only occur once in URLSearchParams
      // but it's wrapped in an array anyway because the API expects that
    }
  }

  // TODO: validate values?
  return obj;
}

export { parseFilters };
